import React, { memo } from 'react';
import LeadTimeChart from '../charts/LeadTimeChart';

/**
 * Card wrapper for the Lead Time for Changes DORA chart.
 */
const LeadTimeDoraCard = memo(function LeadTimeDoraCard({
  loading,
  noData,
  dates = [],
  leadTimeMinutes = [],
  meanLeadTimeMinutes,
  period,
  chartType,
  onPeriodChange,
  onChartTypeChange,
  emptyMessage = 'No lead time data in this window.',
}: any) {
  const hasChartData =
    Array.isArray(dates) &&
    dates.length > 0 &&
    Array.isArray(leadTimeMinutes) &&
    leadTimeMinutes.length === dates.length;

  return (
    <div className="card-mdl-static p-4 min-w-0">
      {noData && !loading ? (
        <p className="text-sm text-slate-400">{emptyMessage}</p>
      ) : (
        <LeadTimeChart
          dates={hasChartData ? dates : []}
          leadTimeMinutes={hasChartData ? leadTimeMinutes : []}
          meanLeadTimeMinutes={hasChartData ? meanLeadTimeMinutes : undefined}
          period={period}
          chartType={chartType}
          onPeriodChange={onPeriodChange}
          onChartTypeChange={onChartTypeChange}
          loading={loading}
        />
      )}
    </div>
  );
});

export default LeadTimeDoraCard;
